import { AlertDates, AlertPayload, AlertResponse } from '@shared/widgets/entities/alerts';
import { environment as ENV } from '@environment';
import { FlightType } from '@search-bar/entities/flight-type';
import { User } from '@app/modules/core/interfaces/user';
import { SearchBarState } from '@shared/base-search-bar/store/state/search-bar.state';
import { AutocompletePlace } from '@shared/base-search-bar/entities/autocomplete';
import { alertDateBoundFormat } from '@shared/widgets/mappers/alert-date-format.mapper';

export function alertPayloadMapper(user: User, searchData: SearchBarState, directOnly: boolean,
  maxPriceAlert: string | number, flexDates: boolean): AlertPayload {
  return {
    user_id: user.id.toString(),
    departure: searchData.departurePlace.code,
    arrival: searchData.arrivalPlace.code,
    price_max: Number(maxPriceAlert),
    currency: ENV.countryInfo.currency_code,
    direct_only: directOnly ? 1 : 0,
    oneway: searchData.flightType === FlightType.ONEWAY ? 1 : 0,
    countrycode: ENV.countryInfo.iso_code,
    arrival_name: getNamePlaceName(searchData.arrivalPlace),
    departure_name: getNamePlaceName(searchData.departurePlace),
    flex_dates: flexDates ? 1 : 0,
    ...alertDates(searchData, flexDates)
  };
}

export function alertDates(searchData: SearchBarState, flexDates: boolean): AlertDates {
  return {
    outbound_min: alertDateBoundFormat(searchData.departureDate, flexDates),
    outbound_max: alertDateBoundFormat(searchData.departureDate, flexDates, true),
    inbound_min: searchData.flightType === FlightType.ROUNDTRIP &&
      searchData.arrivalDate ? alertDateBoundFormat(searchData.arrivalDate, flexDates) : null,
    inbound_max: searchData.flightType === FlightType.ROUNDTRIP &&
      searchData.arrivalDate ? alertDateBoundFormat(searchData.arrivalDate, flexDates, true) : null,
  };
}

export function withFlexDates(alert: AlertResponse): boolean {
  return !!alert && alert.outbound_min !== alert.outbound_max;
}

function getNamePlaceName(place: AutocompletePlace): string {
  return place.is_airport ? place.country : place.description;
}
